// extracted by mini-css-extract-plugin
export default {"container":"WeekStartingInput_container__FNeld","dayIcon":"WeekStartingInput_dayIcon__S3WaT"};